import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorHandlingService } from '../../../../common/exception/error-handling.service';
import { CRMTopMenu } from '../../../models/crm-top-menu.model';
import { TopMenuItem } from '../../../../common/models/top-menu-item.model';
import { PermissionService } from "../../../../security/permission.service";
// import {employeeService} ''
import { ModuleNameConstant } from "../../../../security/module-name.constant";
import { SessionHelper } from '../../../../common/helpers/session.helper';
import { EmployeeService } from '../../../services/employee.service';
// import * as $ from "jquery";

declare var $: any;
declare var jQuery: any;
declare var unescape: any;

@Component({
    selector: 'app-crm-left-bar',
    templateUrl: './crm-left-bar.component.html'
})

export class CRMLeftBarComponent implements OnInit {
    crmTopMenu: CRMTopMenu;
    companyModulePermissions;

    constructor(public router: Router, private _errorHandler: ErrorHandlingService,
        private permissionService: PermissionService, private employeeService: EmployeeService) {
        this.crmTopMenu = new CRMTopMenu();
        this.crmTopMenu.TopMenuItems = new Array<TopMenuItem>();
    }


    ngOnInit() {
        this.getMyCompanyModulePermissions();
    }

    getMyCompanyModulePermissions() {
        try {
            let userProfileDetail = this.employeeService.getUserProfileDetail();
            //console.log('User Profile Details', {userProfileDetail});
            let roleId = (userProfileDetail) ? userProfileDetail.RoleId : SessionHelper.getUserRoleId();
            //let roleId = SessionHelper.getUserRoleId();
            this.permissionService.getModulePermissions(roleId, ModuleNameConstant.Company).subscribe(res => {
                if (res) {
                    this.companyModulePermissions = res;
                }
            }, error => {
                this._errorHandler.handledError(error, "CRMLeftBarComponent.getMyComponyModulePermissions()");
            });
        } catch (ex) {
            this._errorHandler.handledError(ex, "CRMLeftBarComponent.getMyComponyModulePermissions()");
        }
    }

    private initTopMenu() {
        let tmi1 = new TopMenuItem();
        tmi1.Key = "crm-snaphost";
        tmi1.LinkUrl = "/home/crm/dashboard";
        tmi1.Label = "Snapshot";

        let tmi2 = new TopMenuItem();
        tmi2.Key = "crm-contact";
        tmi2.LinkUrl = "/home/crm/contact";
        tmi2.Label = "Contacts";

        let tmi3 = new TopMenuItem();
        tmi3.Key = "crm-affiliate";
        tmi3.LinkUrl = "/home/crm/affiliate";
        tmi3.Label = "Affliate";

        let tmi4 = new TopMenuItem();
        tmi4.Key = "crm-strategy";
        tmi4.LinkUrl = "/home/crm/strategy";
        tmi4.Label = "Strategy";

        let tmi5 = new TopMenuItem();
        tmi5.Key = "crm-billing";
        tmi5.LinkUrl = "/home/crm/billing";
        tmi5.Label = "Billing";

        let tmi6 = new TopMenuItem();
        tmi6.Key = "crm-reporting";
        tmi6.LinkUrl = "/home/crm/reporting";
        tmi6.Label = "Reporting";

        let tmi7 = new TopMenuItem();
        tmi7.Key = "crm-mycompany";
        tmi7.LinkUrl = "/home/crm/mycompany";
        tmi7.Label = "My Company";

        let tmi8 = new TopMenuItem();
        tmi8.Key = "crm-mycompany";
        tmi8.LinkUrl = "/home/crm/mycompany";
        tmi8.Label = "Test";

        this.crmTopMenu.TopMenuItems.push(tmi1);
        this.crmTopMenu.TopMenuItems.push(tmi2);
        this.crmTopMenu.TopMenuItems.push(tmi3);
        this.crmTopMenu.TopMenuItems.push(tmi4);
        this.crmTopMenu.TopMenuItems.push(tmi5);
        this.crmTopMenu.TopMenuItems.push(tmi6);
        this.crmTopMenu.TopMenuItems.push(tmi7);
        this.crmTopMenu.TopMenuItems.push(tmi8);
    }
    //top nav script
    doProfilePicChange() {
    }

    openUserProfileSidebar() {
        try {

        } catch (ex) {
            this._errorHandler.handledError(ex, "TopBar.openUserProfileSidebar");
        }
    }


    /*
   * calling help & support popup and loading data
   */
    help() {
    }

    closewidth() {

    }
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/components/menus/left-bar/crm-left-bar.component.ts